module.exports = __webpack_public_path__ + "static/media/EXERGUECHAP0.4ba6f53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/EXERGUECHAP0.png
// module id = 249
// module chunks = 0